<div *ngIf="visible" class="container">
    <div class="dialog">
        <h2>{{ title }}</h2>
        <p>{{ body }}</p>
        <button type="button" class="confirm-button" (click)="closePopup()">Vredu</button>
    </div>
</div>